"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.FormContent = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _components = require("../../../../components");
var _concernFormContext = require("../../../../contexts/concernFormContext");
var _models = require("../../../../models");
var _constants = require("./constants");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
// eslint-disable react/jsx-no-bind  --temp fix
const FormContent = ()=>{
    const { concernFormData, concernFormConfig, editable } = (0, _concernFormContext.useConcernForm)();
    const { getTestId } = (0, _testidGenerator.default)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_styles.Root, {
        "data-testid": getTestId(_constants.FORM_CONTENT),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormTextAreaField, {
                required: true,
                id: _models.ConcernFormFields.TextAreaFieldInput1,
                label: concernFormData.questions[0],
                disabled: !editable,
                limit: concernFormConfig.characterLimitForATextArea
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormTextAreaField, {
                required: true,
                id: _models.ConcernFormFields.TextAreaFieldInput2,
                label: concernFormData.questions[1],
                disabled: !editable,
                limit: concernFormConfig.characterLimitForATextArea
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormTextAreaField, {
                required: true,
                id: _models.ConcernFormFields.TextAreaFieldInput3,
                label: concernFormData.questions[2],
                disabled: !editable,
                limit: concernFormConfig.characterLimitForATextArea
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormRadioButtonField, {
                required: true,
                id: _models.ConcernFormFields.RadioButtonFieldInput4,
                label: concernFormData.questions[3],
                disabled: !editable,
                radioButtonYes: concernFormData.radioButtonYes,
                radioButtonNo: concernFormData.radioButtonNo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormRadioButtonField, {
                required: true,
                id: _models.ConcernFormFields.RadioButtonFieldInput5,
                label: concernFormData.questions[4],
                disabled: !editable,
                radioButtonYes: concernFormData.radioButtonYes,
                radioButtonNo: concernFormData.radioButtonNo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormRadioButtonField, {
                required: true,
                id: _models.ConcernFormFields.RadioButtonFieldInput6,
                label: concernFormData.questions[5],
                disabled: !editable,
                radioButtonYes: concernFormData.radioButtonYes,
                radioButtonNo: concernFormData.radioButtonNo
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormTextField, {
                id: _models.ConcernFormFields.TextFieldInput7,
                label: concernFormData.questions[6],
                disabled: !editable,
                limit: concernFormConfig.characterLimitForATextField
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.FormTextAreaField, {
                id: _models.ConcernFormFields.TextAreaFieldInput9,
                label: concernFormData.questions[8],
                disabled: !editable,
                limit: concernFormConfig.characterLimitForATextArea
            })
        ]
    });
};
exports.FormContent = FormContent;
